import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { link } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  --textLinkColour: ${brand.global.black};

  position: relative;
  display: inline-block;
`;
const Button = styled.button `
  ${ButtonReset};
  ${fonts.lato.bold};

  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  height: ${fluid(36, 50)};
  border: 1px solid ${brand.primary.purple.light};
  border-radius: 50px;
  position: relative;

  svg {
    width: 24px;

    &:nth-of-type(2) {
      ${transition('transform')};
    }
  }

  &:focus-visible,
  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  &[aria-expanded='true'] {
    svg:nth-of-type(2) {
      transform: rotate(180deg);
    }
  }

  @media ${until(Device.DesktopSmall)} {
    justify-content: center;
    aspect-ratio: 1;
    color: ${brand.grey.dark};

    svg:nth-of-type(2),
    span {
      display: none;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    ${transition('background-color, color')};

    padding-left: ${fluid(16, 20)};
    padding-right: ${fluid(14, 16)};
    background-color: ${brand.primary.purple.light};
    color: ${brand.global.white};

    &:focus-visible,
    &.focus-ring,
    &:hover {
      background-color: transparent;
      color: ${brand.global.black};
    }
  }
`;
const ActiveIndicator = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  display: grid;
  place-content: center;
  height: ${fluid(12, 14)};
  width: ${fluid(12, 14)};
  background-color: ${brand.primary.purple.light};
  color: ${brand.global.white};
  border-radius: 50%;

  svg {
    display: block;
    width: 100%;
  }

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const Links = styled.ul `
  ${transition('opacity, transform')};

  position: absolute;
  top: calc(100% + 16px);
  right: 0;
  background-color: ${brand.primary.grey};
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 23px;
  padding: 12px;
  border-radius: 10px;
  min-width: 252px;

  ${Container}:has(${Button}[aria-expanded='false']) & {
    opacity: 0;
    pointer-events: none;
    transform: translateY(-20px);
  }
`;
const Link = styled.a `
  ${fonts.lato.semiBold};
  ${link};

  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  line-height: 32px;
  white-space: nowrap;

  > svg {
    display: block;
    width: 24px;
  }
`;
const AccountDropdownStyles = {
    Button,
    Container,
    Link,
    Links,
    ActiveIndicator,
};
export default AccountDropdownStyles;
